import * as React from 'react';
import styled from 'styled-components';//emotion:chakuraUI(型付与)

type Props = {
    canvasRef:React.MutableRefObject<HTMLCanvasElement>,
}
export const Canvas: React.FC<Props> = (props) => {
  const CanvasDiv = styled.div`
    display: contents;
    position: absolute;
    height: 300px;
    z-index: 10;
  `;
  const CanvasComponent = styled.canvas`
    width:100%;
    object-fit:cover;

  `;
  // object-fit: fill;
return (
    <CanvasDiv id='canvasdiv'>
        <CanvasComponent ref={props.canvasRef} id='js-canvas'></CanvasComponent>
    </CanvasDiv>
  );
};